import { render } from "./GlobalLoader.vue?vue&type=template&id=4049fde4&ts=true"
import script from "./GlobalLoader.vue?vue&type=script&lang=ts"
export * from "./GlobalLoader.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Xabie\\OneDrive\\Desktop\\Proyectos\\Dream\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__